import React from 'react'
import classNames from 'classnames'

import { Checkbox as BaseCheckbox, Toggle } from '@/components/forms/Checkbox'
import { FormField } from '@/components/forms/FormField'

import './Checkbox.scss'

export const Checkbox = ({
  label,
  field: { name, value, ...fieldProps },
  inline = true,
  reverse = false,
  required, // not implemented
  form,
  meta, // swallowed: callers spreading Formik's render-prop bag would leak it to the DOM
  toggle = false,
  ...props
}) => {
  const Control = toggle ? Toggle : BaseCheckbox

  return (
    <FormField
      className={classNames({
        'checkbox-vertical-label': !inline,
        'checkbox-reverse-label': reverse,
      })}
    >
      {label && (!inline || reverse) && <label>{label}</label>}
      <FormField inline={inline}>
        <Control
          data-testid={`checkbox-${name}`}
          id={name}
          label={inline && !reverse ? label : null}
          name={name}
          checked={!!value}
          {...fieldProps}
          {...props}
        />
      </FormField>
    </FormField>
  )
}
